export default "__VITE_ASSET__DVA2Yhkl__"